import React from 'react'
import Layout from "../components/App/Layout"
import Navbar from "../components/App/Navbar"
import PageBanner from '../components/Common/PageBanner'
import Footer from "../components/App/Footer"
import BlogCard from '../components/BlogContent/BlogCard'

const Blog = () => {
    return (
        <Layout
            titulo="Blog"
            descripcion="Espacio donde expresamos nuestro sentir sobre el ramo de la tecnología y todo lo relacionado con ella"
            slug="blog"
            imagen="https://res.cloudinary.com/dev-empty/image/upload/v1617680073/service2_928ea23787.png"
        >

            <Navbar />

            <PageBanner
                pageTitle="Blog" 
                homePageText="Home" 
                homePageUrl="/" 
                activePageText="Blog" 
            />

            <BlogCard />

            <Footer />
            
        </Layout>
    );
}

export default Blog;